import React, { useEffect, useState } from 'react';
import { useAppSelector } from '@store/hooks';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaArrowLeftLong } from 'react-icons/fa6';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import {
    getDataUuid,
    getDataUsingDeviceId,
    getDataUsingUserId,
    formatDateDMY,
} from '@utils/sharedUtils';
import { DEVICE_CHANGE_LOG_TABLE } from '@constants/dynamoDBTableName';
import { AUDIT_LOG_PATH } from '@constants/routes';
import Swal from 'sweetalert2';

const MySwal = Swal;

type NurseDetails = {
    name: string;
    newValue: string;
};

interface DeviceDetailsModalProps {
    show: boolean;
    onHide: () => void;
}

const DeviceDetailsModal: React.FC<DeviceDetailsModalProps> = ({
    show,
    onHide,
}) => {
    const deviceDetails = useAppSelector((state) => state.user.auditLog);
    const { t } = useTranslation();
    const [nurseDetails, setNurseDetails] = useState<NurseDetails[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (!deviceDetails) {
            navigate(AUDIT_LOG_PATH);
        }
    }, [deviceDetails, navigate]);

    return (
        <Modal show={show} onHide={onHide} size="xl">
            <Modal.Header closeButton>
                <Modal.Title>{t('audit_log_detail.title')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col">
                        <div className="py-3">
                            <label className="font-bold text-black">
                                {t('audit_log_detail.action')}:
                            </label>
                            <span className="ml-3">
                                {deviceDetails?.action || '--'}
                            </span>
                        </div>
                        <div className="py-3">
                            <label className="font-bold text-black">
                                {t('audit_log_detail.user')}:
                            </label>
                            <span className="ml-3">
                                {deviceDetails?.user_id || '--'}
                            </span>
                        </div>
                    </div>
                    <div className="col">
                        <div className="py-3">
                            <label className="font-bold text-black">
                                {t('audit_log_detail.host')}:
                            </label>
                            <span className="ml-3">
                                {deviceDetails?.host || '--'}
                            </span>
                        </div>
                        <div className="py-3">
                            <label className="font-bold text-black">
                                {t('audit_log_detail.time_stamp')}:
                            </label>
                            <span className="ml-3">
                                {deviceDetails?.timestamp || '--'}
                            </span>
                        </div>
                    </div>
                    <div className="col">
                        <div className="py-3">
                            <label className="font-bold text-black">
                                {t('audit_log_detail.model_type')}:
                            </label>
                            <span className="ml-3">
                                {deviceDetails?.model_type || '--'}
                            </span>
                        </div>
                        <div className="py-3">
                            <label className="font-bold text-black">
                                {t('audit_log_detail.time')}:
                            </label>
                            <span className="ml-3">
                                {deviceDetails?.time || '--'}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="py-3">
                            <label className="font-bold text-black">
                                {t('audit_log_detail.properties')}:
                            </label>
                            <span className="ml-3">
                                {JSON.stringify(deviceDetails?.properties) ||
                                    '--'}
                            </span>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('device_details.close')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeviceDetailsModal;
